import { styled } from '@mui/system';
import { Box, Typography } from '@mui/material';

export const UserAccountContainer = styled(Box)(({ theme }) => ({
  background: theme.palette.primary.main,
  borderRadius: '12px',
  height: '5.25rem',
  padding: '0px 1rem',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: theme.spacing(2),
  cursor: 'pointer',
  width: '100%',
  transition: 'background-color 0.2s ease',
  '&:hover': {
    backgroundColor: theme.palette.background.secondaryHover,
  },
}));

export const ContentWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'center',
}));

export const TextContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 'fit-content',
});

export const PrimaryText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  marginBottom: 0,
}));
